import React from 'react';
export function Collapse() {
  return <svg width="100%" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 172 172">
      <g fill="currentColor" stroke="none" strokeWidth="1" strokeLinejoin="miter">
        <path d="M140.39388,21.47201l-30.79427,30.79427l-16.43294,-16.43294v43h43l-16.43294,-16.43294l30.79427,-30.79427zM35.83333,93.16667l16.43294,16.43294l-30.79427,30.79427l10.13411,10.13411l30.79427,-30.79427l16.43294,16.43294v-43z"></path>
      </g>
    </svg>;
}